// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a7b09f87","703":"98d37176"}[chunkId] + ".chunk.js";
};